import { configureStore } from '@reduxjs/toolkit'
import { reducer as snackbar } from 'components/snackbar/snackbar.slices'
import { useSelector, type TypedUseSelectorHook } from 'react-redux'

import { mainSplitApi } from './mainSplitApi'
import { reducer as application } from './store/application.slices'

export const store = configureStore({
  reducer: {
    snackbar,
    application,
    [mainSplitApi.reducerPath]: mainSplitApi.reducer
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
    }).concat(mainSplitApi.middleware)
  }
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const dispatch = store.dispatch
